import { useGetSalesRulesQuery } from 'Services/ProductManagement/Features/SalesRule/salesRuleApi'
import type { FetchSalesRuleListParams } from 'Services/ProductManagement/Features/SalesRule/types'
import { ROWS_PER_PAGE_DEFAULT, SORT_ORDER_ASC } from 'Util/constants'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

export const SELECTED_SALES_RULE_PARAMETER_KEY = 'selectedSalesRule'

export default function useSalesRulesWithParams() {
  const [searchParams, setSearchParams] = useSearchParams()

  const [params, setParams] = useState<FetchSalesRuleListParams>({
    filter: searchParams.get('filter') ?? undefined,
    search_text: searchParams.get('search_text') ?? undefined,
    sort_by: searchParams.get('sort_by') ?? 'id',
    sort_order: searchParams.get('sort_order') ?? SORT_ORDER_ASC,
    start_index: searchParams.get('start_index') ?? undefined,
    count: ROWS_PER_PAGE_DEFAULT,
    zone_requirements: searchParams.get('zone_requirements') ?? undefined
  })

  const {
    data: { resources: salesRules } = { resources: [] },
    data: { total_results: totalResults } = { total_results: 0 },
    isLoading,
    isFetching
  } = useGetSalesRulesQuery(params, { refetchOnMountOrArgChange: true })

  const selectedSalesRuleQueryParam =
    searchParams.get(SELECTED_SALES_RULE_PARAMETER_KEY) ?? undefined
  const [selectedSalesRuleId, setSelectedSalesRuleId] = useState(selectedSalesRuleQueryParam)

  const setQueryParams = () => {
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        searchParams.set(key, value.toString())
      } else {
        searchParams.delete(key)
      }
    })

    selectedSalesRuleId && searchParams.set(SELECTED_SALES_RULE_PARAMETER_KEY, selectedSalesRuleId)

    setSearchParams(searchParams)
  }

  useEffect(() => {
    setQueryParams()
  }, [params])

  useEffect(() => {
    if (selectedSalesRuleId) {
      setQueryParams()
    } else {
      searchParams.delete(SELECTED_SALES_RULE_PARAMETER_KEY)
      setSearchParams(searchParams)
    }
  }, [selectedSalesRuleId])

  return {
    salesRules,
    loading: isLoading || isFetching,
    totalResults,
    params,
    setParams,
    selectedSalesRuleId,
    setSelectedSalesRuleId
  }
}
